module.exports = __webpack_public_path__ + "img/zebra.9a29dc9.png";